// extracted by mini-css-extract-plugin
export default {"zoomModal":"vga-z","image":"wga-z","button":"xga-z","isOverlayShown":"yga-z"};